<tt-page-heading ttModel="p2_m_infoscreen" ttTranslate>
    <span
        class="fa-fw"
        (click)="editing = !editing"
        style="font-size: var(--tt-font-size-xl); margin-left: 0.6rem; position: relative; cursor: pointer; display: inline-block; height: var(--tt-font-size-xl)"
    >
        <span class="fa-fw fal fa-pencil" style="position: absolute; top: 0"></span>
        <span *ngIf="editing" class="fa-fw fal fa-slash" style="position: absolute; top: 0"></span>
    </span>
    <span
        class="fa-fw"
        (click)="dashboard?.refreshAllWidgets()"
        matTooltipShowDelay="500"
        style="font-size: var(--tt-font-size-xl); margin-left: 1.8rem; position: relative; cursor: pointer; display: inline-block; height: var(--tt-font-size-xl)"
    >
        <span class="fa-fw fal fa-sync-alt" [ngClass]="{ 'fa-spin': reloadingData }" style="position: absolute; top: 0; left: 0"></span>
    </span>
</tt-page-heading>

<tt-webpagemenu-dashboard #dashboard style="margin-top: 3rem" [ttEdit]="editable && editing" ttName="infoscreen" ttArgtype="webpage_name" ttArgvalue="infoscreen" [(ttReloadingData)]="reloadingData"></tt-webpagemenu-dashboard>
